import { generatePath } from "react-router-dom"
import { Context } from "../../types"
import { StudyPlanTargets } from "../../../../machines/studyPlan/types"
import {
  BASE_PATH,
  STUDY_PLAN_V2_TARGET_SUBPAGE_MAP
} from "../../../../study-plans/pages/StudyPlansV2/constants"
import { SubPagesEnum } from "../../../../study-plans/pages/StudyPlansV2/types"

export const getSPV2RedirectSubpage = (currentTarget: StudyPlanTargets) => {
  if (!!STUDY_PLAN_V2_TARGET_SUBPAGE_MAP[currentTarget]) {
    return STUDY_PLAN_V2_TARGET_SUBPAGE_MAP[currentTarget]
  }

  if (currentTarget === StudyPlanTargets.TeacherView) {
    return SubPagesEnum.manage
  }

  if (currentTarget === StudyPlanTargets.Edit) {
    return "edit"
  }

  if (currentTarget === StudyPlanTargets.ViewRecommended) {
    return "view"
  }

  return undefined
}

export const setSPV2RedirectUrl = (
  ctx: Context,
  _evt,
  meta: any,
  currentTarget: StudyPlanTargets
) => {
  // Don't redirect if no program or if we're in before_login state
  if (!ctx.program || meta?.state?.value === "before_login") {
    return {}
  }

  const path = generatePath(`${BASE_PATH}/:subpage?`, {
    subpage: getSPV2RedirectSubpage(currentTarget)
  })

  // Remove trailing slashes and clean up path
  const cleanPath = path.replace(/\/+$/, "").replace(/\/+/g, "/")

  return {
    currentTarget: currentTarget,
    redirectUrl: {
      path: cleanPath,
      action: (meta?.action?.action ?? "push") as "push" | "replace"
    }
  }
}
